import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Repos\\Orto_App_New\\FrontEnd\\orto-web\\src\\components\\loader.tsx");
